import PropTypes from 'prop-types'
import React from 'react'
import find from 'lodash/find'
import matches from 'lodash/matches'
import * as PaymentUtils from '@/checkout-instore-legacy/utils/PaymentUtils'
import PaymentItem from '@/checkout-instore-legacy/components/Commons/PaymentItem'
import { buildChildId } from '@/checkout-instore-legacy/utils/TestUtils'
import { getInstallmentMaxValue } from '../paymentHelper'

export default function PaymentList({
  id,
  initialIndex,
  paymentSystems,
  installmentOptions,
  payments,
  onSelectInstallment,
  renderActions,
}) {
  return (
    <div id={id} className="">
      {payments.map((payment, zeroBasedIndex) => {
        // this allow payments been selected before this list
        const index = initialIndex + zeroBasedIndex

        const paymentSystem = find(
          paymentSystems,
          matches({
            stringId: payment.paymentSystem,
          })
        )
        const installments = PaymentUtils.getPaymentSystemInstallments(
          paymentSystem,
          installmentOptions,
          { value: payment.referenceValue }
        )
        const numberOfInstallments = installments
          ? getInstallmentMaxValue(installments)
          : null

        const itemId = buildChildId(['item', index], id)

        return (
          <PaymentItem
            className="bb b--black-10"
            id={itemId}
            key={index}
            paymentName={paymentSystem.name}
            paymentSystemId={paymentSystem.id}
            groupName={paymentSystem.groupName}
            value={payment.referenceValue}
            numberOfInstallments={numberOfInstallments}
            showInstallmentPicker
            onSelectInstallment={(installments) =>
              onSelectInstallment(payment, index, installments)
            }
            selectedInstallment={payment.installments}
            installments={installments}
          >
            {renderActions &&
              renderActions({ index, payment, parentId: itemId })}
          </PaymentItem>
        )
      })}
    </div>
  )
}

PaymentList.defaultProps = {
  initialIndex: 0,
}

PaymentList.propTypes = {
  id: PropTypes.string,
  initialIndex: PropTypes.number,
  paymentSystems: PropTypes.array.isRequired,
  installmentOptions: PropTypes.array,
  payments: PropTypes.array.isRequired,
  onSelectInstallment: PropTypes.func.isRequired,
  renderActions: PropTypes.func,
}
